import $ from 'jquery';

class Hero {
    constructor() {       
        this.videoElement = $('.hero-video-container');
        this.video = $('.js-webp-poster');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		this.handleVideoButtonPosition();
        this.handleVideoPlayButton();
        this.handleMobileVideoPlayButton();
    }

    handleVideoButtonPosition() {        
        this.videoButtonPositionConditions();

        $(window).resize(() => {            
            this.videoButtonPositionConditions();	
            this.video = $('.js-webp-poster');
		});
    }

    handleMobileVideoEnded() {
        this.video.on('ended', () => {
            if ($(window).width() <= 968) { 
                $('.js-video').fadeToggle();
                $('.js-video').toggleClass('playing');
                $('.hero-video-button').fadeToggle();  
            }
        });
    }

    handleVideoPlayButton() {
        $('body').on('click', '.hero-video-button', () => {
            let youtubeVideo = $('.hero-video-button').attr('data-video');
            if (youtubeVideo !== '') {                
                $('#hero-youtube-video').attr('src', `https://www.youtube.com/embed/${youtubeVideo}?si=dIBry6GF-kcw6Rr3&autoplay=1&mute=1&rel=0&enablejsapi=1`);
            } 
            else
            {
                this.video.trigger('play');
                this.handleMobileVideoEnded();
            }


            if ($(window).width() <= 968) {            
                $('.js-video').fadeToggle();
                $('.js-video').toggleClass('playing');
                $('.hero-video-button').fadeToggle();     
                return;
            }  

            let contentSource = $('.hero-video-container');
            $('.hero-video-button').modaal({
                type: 'inline',
                content_source: contentSource,
                start_open: true
            });
        });         
    }

    handleMobileVideoPlayButton() {
        $('body').on('click', '.hero-video-button-mobile', () => {
            if ($(window).width() > 968) {
                return;
            }

            let youtubeVideo = $('.hero-video-button-mobile').attr('data-video') || '';
            if (youtubeVideo !== '') {
                $('#hero-youtube-video').attr('src', `https://www.youtube.com/embed/${youtubeVideo}?si=dIBry6GF-kcw6Rr3&autoplay=1&mute=1&rel=0&enablejsapi=1`);
            }

            let contentSource = $('.hero-video-container');
            $('.hero-video-button-mobile').modaal({
                type: 'inline',
                content_source: contentSource,
                start_open: true,
                after_open: () => {
                    if (youtubeVideo === '') {
                        this.video.trigger('play');
                    }
                },
                after_close: () => {
                    if (youtubeVideo !== '') {
                        $('#hero-youtube-video').attr('src', '');
                    } else {
                        const videoElement = this.video.get(0);
                        if (videoElement) {
                            videoElement.pause();
                            videoElement.currentTime = 0;
                        }
                    }
                }
            });
        });
    }

    videoButtonPositionConditions() {
        let videoButton = $('.hero-video-button');
        let heroImageContainer = $('.hero-image');
        let videoButtonContainer = $('.hero-video-button-container');
        let video = $('.js-video');

        heroImageContainer.empty();
        videoButtonContainer.empty();
        $(videoButtonContainer).css({ position: 'initial' });
        heroImageContainer.append(this.videoElement);
        this.video = $('.js-webp-poster');
        if ($(window).width() <= 968) {
            heroImageContainer.append(videoButton);
            if (video.hasClass('playing')) {
                video.show();
                videoButton.hide();
            }
            return;
		}
        videoButtonContainer.append(videoButton);
        video.hide();
        videoButton.show();
    }
}

export default Hero;

$(() => {
	const hero = new Hero();
	hero.init();
});
